import { environment } from "@environments/environment";
import { ResourcesConfig } from "aws-amplify";

const awsconfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: environment.userPoolId,
      userPoolClientId: environment.userPoolWebClientId,
      // signUpVerificationMethod: 'code',
      // region: environment.region,
      loginWith: {
        oauth: {
          domain: environment.authDomain,
          scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [environment.redirectSignIn],
          redirectSignOut: [environment.redirectSignOut],
          responseType: 'code'
        }
      }
    }
  }
};

export default awsconfig;